import { Slider } from "@mui/material";

import { useFilterContext } from "../FilterContext";

const FilterItemSeats = () => {
  const { filterData, setFilterData } = useFilterContext();

  return (
    <div className="pt-[40px] pb-[12px] px-[40px]">
      <Slider
        valueLabelDisplay="on"
        min={1}
        max={9}
        step={1}
        value={filterData.seats}
        onChange={(e, v) => {
          setFilterData({
            seats: v as number,
          });
        }}
      />
    </div>
  );
};

export default FilterItemSeats;
